/* ==========================================================================
   Solzaleben, merkpagina (template collection.marke).

   1. "Mehr Böden laden": de knop is een echte link naar ?page=N. Met
      JavaScript halen we alleen de rastersectie van die pagina op (section
      rendering), hangen de kaarten onder de bestaande en zetten knop en
      paginanummers op de nieuwe stand. De URL in de adresbalk blijft gelijk.
      Mislukt het ophalen, dan volgt de browser gewoon de link.
   2. Ansprechpartner in de Bid & Buy-band: dezelfde persoon als op de PDP,
      uit sessionStorage solza-bid-contact (solza-pdp-bid.js zet die). Nog
      geen keuze: willekeurig een actieve persoon en die bewaren.
   ========================================================================== */
(function () {
  'use strict';

  if (window.SolzaMerk) return;
  window.SolzaMerk = true;

  /* -------------------------------------------------------- Mehr Böden laden */
  function laadMeer(knop) {
    var wrap = knop.closest('[data-solza-mehr-wrap]');
    var lijst = document.getElementById('ProductsList');
    if (!wrap || !lijst) return false;

    var url = new URL(knop.href, window.location.href);
    url.searchParams.set('section_id', wrap.getAttribute('data-section-id'));

    knop.setAttribute('aria-busy', 'true');
    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('status ' + antwoord.status);
        return antwoord.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nieuweLijst = doc.getElementById('ProductsList');
        var nieuweWrap = doc.querySelector('[data-solza-mehr-wrap]');
        if (!nieuweLijst) throw new Error('geen lijst');

        var eersteNieuwe = null;
        Array.prototype.slice.call(nieuweLijst.children).forEach(function (kind) {
          if (!eersteNieuwe) eersteNieuwe = kind;
          lijst.appendChild(kind);
        });

        // Knop en paginanummers van de nieuwe pagina overnemen; de regel
        // "Du siehst …" blijft staan en telt de kaarten.
        var stand = wrap.querySelector('[data-solza-mehr-stand]');
        if (nieuweWrap) {
          Array.prototype.slice.call(wrap.children).forEach(function (kind) {
            if (kind !== stand) kind.remove();
          });
          Array.prototype.slice.call(nieuweWrap.children).forEach(function (kind) {
            if (!kind.hasAttribute('data-solza-mehr-stand')) wrap.appendChild(kind);
          });
        } else {
          knop.remove();
        }
        if (stand) {
          var getoond = stand.querySelector('[data-solza-mehr-getoond]');
          if (getoond) getoond.textContent = lijst.querySelectorAll('.product-column').length;
        }
        // Focus naar de eerste nieuwe kaart, zodat toetsenbordgebruikers verder kunnen.
        var link = eersteNieuwe && eersteNieuwe.querySelector('a[href]:not([tabindex="-1"])');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = knop.href;
      });
    return true;
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-solza-mehr]');
    if (!knop || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    if (knop.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    if (laadMeer(knop)) event.preventDefault();
  });

  /* --------------------------------------------------------- Ansprechpartner */
  function toonContact() {
    var sjablonen = Array.prototype.slice.call(document.querySelectorAll('template[data-solza-merk-contact]'));
    if (sjablonen.length < 2) return;
    var sleutels = sjablonen.map(function (t) { return t.getAttribute('data-solza-merk-contact'); });
    var gekozen = null;
    try {
      gekozen = window.sessionStorage.getItem('solza-bid-contact');
    } catch (_fout) {
      gekozen = null;
    }
    if (sleutels.indexOf(gekozen) === -1) {
      gekozen = sleutels[Math.floor(Math.random() * sleutels.length)];
      try {
        window.sessionStorage.setItem('solza-bid-contact', gekozen);
      } catch (_fout) {
        /* geen opslag: volgende pagina kiest opnieuw */
      }
    }
    var sjabloon = sjablonen[sleutels.indexOf(gekozen)];
    var naam = sjabloon.getAttribute('data-naam');
    try {
      window.sessionStorage.setItem('solza-bid-contact-naam', naam);
    } catch (_fout) {
      /* niets */
    }
    var foto = sjabloon.content.querySelector('img');
    var fotoSlot = document.querySelector('[data-solza-merk-contact-foto]');
    if (foto && fotoSlot) {
      fotoSlot.innerHTML = '';
      fotoSlot.appendChild(foto.cloneNode(true));
    }
    document.querySelectorAll('[data-solza-merk-contact-naam]').forEach(function (el) {
      el.textContent = naam;
    });
  }

  /* ------------------------------------------------------- Trusted Shops-badge */
  // Het zwevende badge valt over chips en kaarten. Zolang die in beeld
  // zijn krijgt body de klasse solza-badge-weg; de CSS verbergt het badge dan.
  function badgeUitDeWeg() {
    if (!('IntersectionObserver' in window)) return;
    var doelen = Array.prototype.slice.call(document.querySelectorAll('.solza-merk-chips, #ProductGridContainer'));
    if (!doelen.length) return;
    var zichtbaar = new Set();
    var waarnemer = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) zichtbaar.add(item.target);
        else zichtbaar.delete(item.target);
      });
      document.body.classList.toggle('solza-badge-weg', zichtbaar.size > 0);
    });
    doelen.forEach(function (doel) { waarnemer.observe(doel); });
  }

  /* ------------------------------------------------------------ Actieve chip */
  // Mobiel scrolt de rij bodemsoorten zijwaarts. Staat de actieve chip buiten
  // beeld (bv. Hybrid Holz), dan schuiven we de rij zo dat hij zichtbaar is.
  function toonActieveChip() {
    var rij = document.querySelector('.solza-merk-chips');
    var actief = rij && rij.querySelector('[aria-current]');
    if (!actief || rij.scrollWidth <= rij.clientWidth) return;
    var links = actief.offsetLeft - rij.offsetLeft;
    var rechts = links + actief.offsetWidth;
    if (links >= rij.scrollLeft && rechts <= rij.scrollLeft + rij.clientWidth) return;
    rij.scrollLeft = Math.max(0, rechts - rij.clientWidth + 16);
  }

  function start() {
    toonActieveChip();
    toonContact();
    badgeUitDeWeg();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
